import { ServiceUsingCountLimiter } from "@/services/license/license-limiters/base-limiters/service-using-count-limiter";
import { LicenseName } from "@/data/license.data";

export const trialMastersCount = 4;

export class AiMasteringUsingCountLimiter extends ServiceUsingCountLimiter {
  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return trialMastersCount;
      case "Basic":
        return trialMastersCount;
      case "Starter":
        return trialMastersCount;
      case "Creator":
        return trialMastersCount;
      default:
        return Infinity;
    }
  }

  getUniqueLimit(userId: string): Promise<number | null> {
    return Promise.resolve(null);
  }
}
